const webshopKeyToName = {
    bolcom: 'Bol.com',
    lightspeed: 'Lightspeed',
    shopify: 'Shopify',
    woocommerce: 'WooCommerce',
    prestashop: 'PrestaShop',
    magento: 'Magento',
    ccvshop: 'CCV Shop',
    mijnwebwinkel: 'Mijnwebwinkel',
    shoptrader: 'Shoptrader',
    exactOnline: 'Exact Online',
    shopware: 'Shopware'
}

export default webshopKeyToName
